<template>
	<layout-admin>
		<div class="py-6 px-4 sm:px-6 lg:px-8">
			<ui-alert
				v-if="success"
				type="success"
				:message="success == true ? 'Your inputs have been saved!' : success"
			/>
			<ui-alert v-if="error" type="error" :message="error" />

			<div class="pb-8 px-6 fixed bottom-0 flex right-0 z-10">
				<ui-button
					class="ml-auto text-lg shadow-xl"
					label="Save"
					v-on:click="submitForm()"
					:disabled="submitButtonDisabled"
				/>
			</div>

			<h1 class="text-3xl font-semibold text-gray-900 mb-4">
				{{ __("Marktkompass Ausgabe erstellen") }}
			</h1>

			<div class="pb-8 px-6 fixed top-24 flex right-0 z-10">
				<ui-button
					type="secondary"
					v-on:click="$inertia.visit(backUrl)"
					class="flex items-center"
				>
					{{ __("Back") }}
				</ui-button>
			</div>

			<admin-market-news-fields :form="form" />
		</div>
	</layout-admin>
</template>

<script>
import Vue from "vue";
export default {
	props: {
		news: {
			type: Object,
			required: true,
		},
		success: {
			default: false,
		},
		error: {
			type: String,
			required: false,
		},
	},
	data() {
		return {
			form: Vue.observable(this.$inertia.form(this.news)),
			submitButtonDisabled: false,
		};
	},
	computed: {
		backUrl() {
			return window.baseUrl + "/admin/market-news";
		},
	},
	created() {
		//console.log(this.initialData);
	},
	methods: {
		async submitForm() {
			let endpoint = this.$page.url,
				method = "post",
				that = this;

			this.submitButtonDisabled = true;
			this.form.submit(method, endpoint, {
				preserveState: true,
				onSuccess(p) {
					console.log("SUCCESS SUBMISSION, got: ", p);
				},
				onFinish(e) {
					that.submitButtonDisabled = false;
					console.log("submit FINISH", method, endpoint, "got:", e);
				},
			});
		},
	},
};
</script>
